const LDClient = window ? window.LDClient : null

const evaluatedSessionFlags = {}

const LD_EXPERIMENT_IMPRESSIONS_KEY = 'ld_experiment_impressions'

const FS_FEATURE_FLAGS = ['CRO_1152_SORT_BY_TOTAL_PRICE', 'CRO_1240_MOBILE_DATE_SELECTOR', 'CRO_1195_UPSELL_PACKAGES_ON_PLP', 'CRO_1202_HIDE_EXIT_DIGIOH_INTENT'];

const fsInspector = {
    type: 'flag-used',
    name: 'fullstory-inspector',
    method: (key, detail) => {
        if (window.FS === undefined || typeof window.FS.getCurrentSessionURL !== 'function') {
            return
        }

        const url = window.FS.getCurrentSessionURL(true)
        if (url === undefined || !FS_FEATURE_FLAGS.includes(key)) {
            return
        }

        evaluatedSessionFlags[url] = {
            ...evaluatedSessionFlags[url],
            [key]: detail.value,
        }

        const arrayOfFlags = Object.keys(evaluatedSessionFlags[url]).map(
            (flagKey) => `${flagKey}=${JSON.stringify(evaluatedSessionFlags[url][flagKey], null, 1)}`
        )

        if (typeof window.FS.setVars === 'function') {
            window.FS.setVars('page', { ldflags: arrayOfFlags }, { integration: 'launchdarkly' })
        }
    },
}

const options = { inspectors: [fsInspector] }

class LDClientWrapper {
    constructor() {
        this.client = undefined;
        this.isMobile = false;
    }

    initialize() {
        const clientId = window.apr && window.apr.launch_darkly_client_id ? window.apr.launch_darkly_client_id : ''
        const defaultContext = this.createDefaultContext();
        if (LDClient && window.Promise && clientId && !this.client) {
            this.client = LDClient.initialize(clientId, defaultContext, options)
        }
    }

    setIsMobile(isMobile) {
        this.isMobile = isMobile;
    }

    createDefaultContext() {
        const anonymousUserContext = {
            kind: 'user',
            anonymous: true,
        }
        const fullPageUrl = window.location.pathname ? window.location.pathname.replace(/^\//, '').split('/') : null
        const fullPageUrlConverted = fullPageUrl ? fullPageUrl[0] : '';
        const pageUrl = fullPageUrlConverted === 'search' ? 'search' : '';

        let airportContext;
        if (pageUrl === 'search') {
            const airport = fullPageUrl ? fullPageUrl[1] : '';
            if (airport) {
                airportContext = {
                    kind: 'airport',
                    key: 'apr-airport',
                    airport: airport,
                };
            }
        }

        const pageContext = {
            kind: 'page',
            key: 'apr-page',
            page: pageUrl,
        }
        const mobileContext = {
            kind: 'mobile',
            key: "mobile",
            mobile: this.isMobile
        }
        const multiContext = {
            kind: 'multi',
            user: anonymousUserContext,
            page: pageContext,
            mobile: mobileContext,
        }

        if (airportContext) {
            multiContext.airport = airportContext;
        }
        return multiContext;
    }

    close() {
        if (this.client) {
            this.client.close()
        }
    }

    getFeatureFlag(flag, defaultValue = false) {
        if (this.client === undefined) {
            return false
        }

        const value = this.client.variation(flag, defaultValue);
        this.addDataLayerEvent(flag, value);

        return value;
    }

    isInExperiment(flag) {
        if (this.client === undefined) {
            return false
        }

        const variationDetail = this.client.variationDetail(flag);
        if (variationDetail === undefined) {
            return false
        }

        return variationDetail.reason && variationDetail.reason.inExperiment === true;
    }

    track(event) {
        if (this.client === undefined) {
            return;
        }

        this.client.track(event);
    }

    addDataLayerEvent(flag, value) {
        if (!this.isInExperiment(flag)) {
            return;
        }

        const ticketId = getTicketId(flag);
        if (!ticketId || getTrackedExperimentImpressions().includes(ticketId)) {
            return;
        }

        window.dataLayer = window.dataLayer || [];
        if (typeof window.dataLayer.push !== 'function') {
            return;
        }

        window.dataLayer.push({
            event: 'experiment_impression',
            experiment_id: ticketId,
            variant_id: getVariantId(value),
        });

        saveTrackedExperimentImpression(ticketId);
    }
}

function getTicketId(flag) {
    const match = flag.match(/^CRO_(\d+)_/i);
    if (!match) {
        return null;
    }

    return `cro-${match[1]}`;
}

function getVariantId(value) {
    if (value === true || value === 'true') {
        return 'variant';
    }

    if (value === false || value === 'false') {
        return 'control';
    }

    return value;
}

function getTrackedExperimentImpressions() {
    try {
        const impressions = localStorage.getItem(LD_EXPERIMENT_IMPRESSIONS_KEY);
        if (!impressions) {
            return [];
        }

        const parsedImpressions = JSON.parse(impressions);
        return Array.isArray(parsedImpressions) ? parsedImpressions : [];
    } catch(error) {
        return [];
    }
}

function saveTrackedExperimentImpression(ticketId) {
    try {
        const impressions = getTrackedExperimentImpressions();
        if (impressions.includes(ticketId)) {
            return;
        }

        impressions.push(ticketId);
        localStorage.setItem(LD_EXPERIMENT_IMPRESSIONS_KEY, JSON.stringify(impressions));
    } catch(error) {
        // no-op
    }
}

const ldClientWrapper = new LDClientWrapper()
export default ldClientWrapper
